import { render, staticRenderFns } from "./PostReg.vue?vue&type=template&id=72c76cb3&"
import script from "./PostReg.vue?vue&type=script&lang=js&"
export * from "./PostReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports